<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Quà tặng chương trình khuyến mại</h3>
      </div>
      <MangeGiftProgramHeaderActions
          @import="handleImport"
          @export="handleExport"
          :loading-export="loadingExport"
      />
    </div>
    <div class="promotion-program__filter">
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Tên quà</span>
        <el-input
            v-model="filters.name"
            clearable class="w-100"
            placeholder="Nhập tên quà"
            @input="debounceFilterGiftPrograms"
        />
      </div>
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Mã khách hàng</span>
        <el-input
            v-model="filters.user_id"
            clearable class="w-100"
            placeholder="Nhập tên khách hàng, mã, sđt"
            @input="debounceFilterGiftPrograms"
        />
      </div>
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Mã hợp đồng</span>
        <el-input
            v-model="filters.contract_id"
            clearable class="w-100"
            placeholder="Nhập mã hợp đồng"
            @input="debounceFilterGiftPrograms"
        />
      </div>
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Trạng thái</span>
        <el-select
            v-model="filters.logistic_user_gift_status"
            clearable
            class="w-100"
            placeholder="Chọn trạng thái"
            @change="filterGiftPrograms"
        >
          <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Thời gian tạo</span>
        <el-date-picker
            v-model="filters.created_at"
            type="daterange"
            class="w-100"
            range-separator="-"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            @change="filterGiftPrograms"
        />
      </div>
      <div class="promotion-filter__item">
        <span class="promotion-filter__label">Mốc theo dõi</span>
        <el-date-picker
            v-model="filters.timeline"
            type="daterange"
            class="w-100"
            range-separator="-"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            @change="filterGiftPrograms"
        />
      </div>
    </div>
    <div class="card-body promotion-program__body">
      <MangeGiftProgramTable
          :records="giftPrograms"
          @change-status="openChangeStatusDialog"
      />
      <div v-if="giftPrograms.length > 0" class="promotion-program__footer">
        <div id="paginate" class="edu-paginate mx-auto d-flex justify-content-center">
          <paginate
              v-model="page"
              :page-count="lastPage"
              :page-range="3"
              :margin-pages="1"
              :click-handler="changePage"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
          />
        </div>
        <div class="promotion-program__total">
          Tổng số bản ghi:
          <b>{{ total }}</b>
        </div>
      </div>
    </div>
    <MangeGiftProgramStatusDialog
        :visible.sync="changeStatusDialog.visible"
        :loading="changeStatusDialog.loading"
        :target-status-label="changeStatusDialog.targetStatusLabel"
        :require-reason="changeStatusDialog.requireReason"
        :note.sync="changeStatusDialog.note"
        @submit="submitChangeStatus"
        @close="resetChangeStatusDialog"
    />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CHANGE_STATUS_SEND_GIFT,
  EXPORT_USER_GIFT,
  GET_LIST_USER_GIFT
} from "@/core/services/store/logistics/logistics.module";
import MangeGiftProgramHeaderActions from "@/view/pages/logistics/components/MangeGiftProgramHeaderActions.vue";
import MangeGiftProgramStatusDialog from "@/view/pages/logistics/components/MangeGiftProgramStatusDialog.vue";
import MangeGiftProgramTable from "@/view/pages/logistics/components/MangeGiftProgramTable.vue";
import {
  giftProgramStatusOptions,
  ManageGiftProgramModel,
  STATUS_LABELS
} from "@/view/pages/logistics/model/ManageGiftProgramModel";
import {exportExcel} from "@/core/filters";
import moment from "moment-timezone";

export default {
  name: 'MangeGiftProgram',
  components: {
    MangeGiftProgramHeaderActions,
    MangeGiftProgramStatusDialog,
    MangeGiftProgramTable
  },
  data() {
    return {
      loading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      filters: {
        name: null,
        user_id: null,
        contract_id: null,
        logistic_user_gift_status: null,
        created_at: [],
        timeline: []
      },
      statusOptions: giftProgramStatusOptions,
      giftPrograms: [],
      loadingExport: false,
      filterDebounceTimeout: null,
      changeStatusDialog: this.getDefaultChangeStatusDialog()
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý kinh doanh" },
      { title: "Quà tặng chương trình khuyến mại" }
    ]);
    this.getParams();
    this.getGiftPrograms();
  },
  methods: {
    getDefaultChangeStatusDialog() {
      return {
        visible: false,
        loading: false,
        record: null,
        actionItem: null,
        targetStatusLabel: "",
        targetStatus: null,
        requireReason: false,
        note: "",
      };
    },
    changePage(page) {
      this.page = page;
      this.updateRouteQuery();
      this.getGiftPrograms();
    },
    filterGiftPrograms() {
      this.page = 1;
      this.updateRouteQuery();
      this.getGiftPrograms();
    },
    debounceFilterGiftPrograms() {
      if (this.filterDebounceTimeout) {
        clearTimeout(this.filterDebounceTimeout);
      }

      this.filterDebounceTimeout = setTimeout(() => {
        this.filterDebounceTimeout = null;
        this.filterGiftPrograms();
      }, 500);
    },
    getGiftPrograms() {
      this.loading = true;
      this.$store.dispatch(GET_LIST_USER_GIFT, this.getFilterPayload()).then(res => {
        if (!res?.error) {
          const response = res?.data || {};
          const list = Array.isArray(response) ? response : response.data || [];
          const pagination = res?.pagination || response.pagination || (Array.isArray(response) ? res : response);

          this.giftPrograms = list.map(item => new ManageGiftProgramModel(item));
          this.page = pagination.current_page || pagination.page || this.page;
          this.lastPage = pagination.last_page || pagination.lastPage || 1;
          this.total = pagination.total || this.giftPrograms.length;
        }
      }).catch(e => {
        console.log(e, "Error get gift program list");
      }).finally(() => {
        this.loading = false;
      });
    },
    getFilterPayload() {
      const createdRange = this.filters.created_at || [];
      const updatedRange = this.filters.timeline || [];

      return {
        page: this.page,
        limit: 20,
        name: this.filters.name,
        user_id: this.filters.user_id,
        contract_id: this.filters.contract_id,
        logistic_user_gift_status: this.filters.logistic_user_gift_status,
        "created_at[0]": createdRange[0] || null,
        "created_at[1]": createdRange[1] || null,
        "timeline[0]": updatedRange[0] || null,
        "timeline[1]": updatedRange[1] || null,
      }
    },
    getParams() {
      const query = this.$route.query;

      this.page = query.page ? Number(query.page) : 1;
      this.filters = {
        name: query.name || null,
        user_id: query.user_id || null,
        contract_id: query.contract_id || null,
        logistic_user_gift_status: query.logistic_user_gift_status ? Number(query.logistic_user_gift_status) : null,
        created_at: query["created_at[0]"] || query["created_at[1]"] ? [
          query["created_at[0]"] || null,
          query["created_at[1]"] || null,
        ] : [],
        timeline: query["timeline[0]"] || query["timeline[1]"] ? [
          query["timeline[0]"] || null,
          query["timeline[1]"] || null,
        ] : [],
      };
    },
    updateRouteQuery() {
      const createdRange = this.filters.created_at || [];
      const updatedRange = this.filters.timeline || [];
      const query = this.cleanQuery({
        page: this.page,
        name: this.filters.name,
        user_id: this.filters.user_id,
        contract_id: this.filters.contract_id,
        logistic_user_gift_status: this.filters.logistic_user_gift_status,
        "created_at[0]": createdRange[0],
        "created_at[1]": createdRange[1],
        "timeline[0]": updatedRange[0],
        "timeline[1]": updatedRange[1],
      });

      this.$router.replace({
        name: 'MangeGiftProgram',
        query,
      }).catch(() => {});
    },
    cleanQuery(query) {
      return Object.keys(query).reduce((result, key) => {
        const value = query[key];
        if (value !== null && value !== undefined && value !== "") {
          result[key] = value;
        }

        return result;
      }, {});
    },
    handleImport() {
      this.$message.info('Chức năng Import đang chờ kết nối API');
    },
    openChangeStatusDialog(record, actionItem) {
      this.changeStatusDialog = {
        ...this.getDefaultChangeStatusDialog(),
        visible: true,
        record,
        actionItem,
        targetStatus: actionItem.targetStatus,
        targetStatusLabel: STATUS_LABELS[actionItem.targetStatus] || "",
        requireReason: actionItem.requireReason,
      };
    },
    resetChangeStatusDialog() {
      if (!this.changeStatusDialog.loading) {
        this.changeStatusDialog = this.getDefaultChangeStatusDialog();
      }
    },
    async submitChangeStatus() {
      const { record, actionItem, note, targetStatus } = this.changeStatusDialog;
      if (!record || !actionItem) return;

      this.changeStatusDialog.loading = true;
      try {
        const res = await this.$store.dispatch(CHANGE_STATUS_SEND_GIFT, {
          id: record.id,
          status: targetStatus,
          note,
        });

        if (!res?.error) {
          this.$message.success("Cập nhật trạng thái quà tặng thành công");
          this.changeStatusDialog.visible = false;
          await this.getGiftPrograms();
        } else {
          this.$message.error(res?.message || "Cập nhật trạng thái quà tặng thất bại");
        }
      } catch (e) {
        console.log(e, "Error change gift status");
        this.$message.error(e?.message || "Cập nhật trạng thái quà tặng thất bại");
      } finally {
        this.changeStatusDialog.loading = false;
      }
    },
    handleExport() {
      this.loadingExport = true;
      const HEADER_ROW_EXPORT_USER_GIFT = [
        {
          key: 'stt',
          value: 'STT',
        },
        {
          key: 'gift_id',
          value: 'Mã quà tặng',
        },
        {
          key: 'name',
          value: 'Tên quà tặng',
        },
        {
          key: 'user_name',
          value: 'Khách hàng',
        },
        {
          key: 'user_id',
          value: 'Mã khách hàng',
        },
        {
          key: 'phone',
          value: 'Số điện thoại khách hàng',
        },
        {
          key: 'contract_id',
          value: 'Mã hợp đồng',
        },
        {
          key: 'logistic_user_gift_status',
          value: 'Trạng thái quà tặng',
        },
        {
          key: 'created_at',
          value: 'Thời gian tạo bản ghi',
        },
        {
          key: 'timeline',
          value: 'Mốc theo dõi',
        },
        {
          key: 'note',
          value: 'Ghi chú lý do',
        },
        {
          key: 'payment_value',
          value: 'Giá trị thanh toán',
        },
        {
          key: 'payment_deadline',
          value: 'Thời hạn thanh toán',
        },
        {
          key: 'branch_name',
          value: 'Chi nhánh',
        },
        {
          key: 'total_paid',
          value: 'Thanh toán',
        },
        {
          key: 'total_after_voucher',
          value: 'Tổng giá trị hợp đồng',
        },
        {
          key: 'total_debt',
          value: 'Công nợ',
        },
        {
          key: 'paid_amount_at_due_date',
          value: 'Số tiền thanh toán tại thời điểm thời hạn thanh toán',
        },
      ]
      this.$store.dispatch(EXPORT_USER_GIFT, this.filters).then(res => {
        if (res.error) {
          this.$bvToast.toast(res.message, {
            title: 'Export excel',
            variant: 'danger',
            solid: true
          });
        } else {
          const data = res.data.map(item => {
            return {
              ...item,
              created_at: this.formatDate(item.created_at),
              timeline: this.formatDate(item.timeline),
            }
          })
          exportExcel(HEADER_ROW_EXPORT_USER_GIFT, data, "Danh sách quà tặng chương trình khuyến mại.xlsx", true)
          this.$bvToast.toast(res.message || "Export thành công", {
            title: 'Export excel',
            variant: 'success',
            solid: true
          });
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loadingExport = false
      })
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const parsedDate = moment(date, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
        moment.ISO_8601,
      ], true);

      return parsedDate.isValid() ? parsedDate.format('DD-MM-YYYY HH:mm:ss') : date;
    },
  },
  beforeDestroy() {
    if (this.filterDebounceTimeout) {
      clearTimeout(this.filterDebounceTimeout);
    }
  }
}
</script>

<style scoped>
.promotion-program__body {
  padding: 20px;
}

.promotion-program__filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
  padding: 10px 30px;
}

.promotion-filter__item {
  width: 100%;
}

.promotion-filter__label {
  display: block;
  color: #222222;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 4px;
}

.promotion-program__footer {
  min-height: 80px;
  position: relative;
}

.promotion-program__footer .edu-paginate {
  margin-top: 110px;
}

.promotion-program__total {
  bottom: 8px;
  color: #111827;
  font-size: 12px;
  position: absolute;
  right: 4px;
}

.promotion-program__total b {
  color: #0066ff;
  margin-left: 4px;
}

@media (max-width: 768px) {
  .promotion-program__filter {
    grid-template-columns: 1fr;
  }

  .promotion-program__footer .edu-paginate {
    margin-top: 32px;
  }

  .promotion-program__total {
    margin-top: 12px;
    position: static;
    text-align: right;
  }
}
</style>
